module.exports = __webpack_public_path__ + "img/collaborate_23.d740fa84.jpg";